import { Component, OnInit,OnChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from '../user.service';
import { Options,LabelType } from '@angular-slider/ngx-slider';


@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.scss']
})
export class QuestionnaireComponent implements OnInit {

  showInfo: boolean = false;
  isVidLoading:boolean = true;
  value: number = 100;
  options: Options = {
    floor: 0,
    ceil: 2,
    step:0.1,
    translate: (value: number, label: LabelType): string => {
          return value+"%"
    }
  };
  options1: Options = {
    floor: 0,
    ceil: 2,
    step:0.1,
    translate: (value: number, label: LabelType): string => {
          return value+"%"
    }
  };
  options2: Options = {
    floor: 0,
    ceil: 60,
    step:0.1,
    translate: (value: number, label: LabelType): string => {
          return value+"%"
    }
  };
  options3: Options = {
    floor: 0,
    ceil: 20,
    step:0.1,
    translate: (value: number, label: LabelType): string => {
          return value+"%"
    }
  };

  currentPortfolioValue: string;
  newPortfolioValue: string;
  currentManagementFee: string;
  currentInvestmentFee: string;
  newManagementFee: string;
  newInvestmentFee: string;
  currentTaxBracket: any;
  newTaxBracket: any;
  currentCostOfLivingIncrease: any;
  newCostOfLivingIncrease: any;


  portfolio_value: any;
  management_fee: Number;
  investment_fee: Number;
  tax_bracket: any;
  cost_of_living_increase: any;

  constructor(private _http: HttpClient,public user:UserService) { }

  ngOnInit() {
    this.user.currentPortfolioValue.subscribe(currentPortfolioValue => {
      this.currentPortfolioValue = currentPortfolioValue;
      this.newPortfolioValue = currentPortfolioValue;
    });
    this.user.currentManagementFee.subscribe(currentManagementFee => {
      this.currentManagementFee = currentManagementFee;
      this.newManagementFee = currentManagementFee;
    });
    this.user.currentInvestmentFee.subscribe(currentInvestmentFee => {
      this.currentInvestmentFee = currentInvestmentFee;
      this.newInvestmentFee = currentInvestmentFee;
    });
    this.user.currentTaxBracket.subscribe(currentTaxBracket => {
      this.currentTaxBracket = currentTaxBracket;
      this.newTaxBracket = currentTaxBracket;
      });
    this.user.currentCostOfLivingIncrease.subscribe(currentCostOfLivingIncrease => {
      this.currentCostOfLivingIncrease = currentCostOfLivingIncrease;
      this.newCostOfLivingIncrease = currentCostOfLivingIncrease;
    });
  }


  saveToLocal(){
    localStorage.removeItem('portfolio_feed')
    let portfolio_feed={
      portfolio_value:String(this.portfolio_value?this.portfolio_value:this.newPortfolioValue) ,
      management_fee:String(this.management_fee?this.management_fee:this.newManagementFee) ,
      investment_fee:String(this.investment_fee?this.investment_fee:this.newInvestmentFee),
      tax_bracket:String(this.tax_bracket?this.tax_bracket:this.newTaxBracket),
      cost_of_living_increase: String(this.cost_of_living_increase?this.cost_of_living_increase:this.newCostOfLivingIncrease)
    }
    localStorage.setItem('portfolio_feed',JSON.stringify(portfolio_feed));
  }

}
